import React from 'react'
import { Table, Spin } from 'antd'

export default function DataTable(props) {
    const { data, columns, pageSize, totalRecords, onTableChange, isLoading, currentPage, customClass = "" } = props
    return (
        <>
            <Table className={customClass} rowKey={"id"} dataSource={data} columns={columns} pagination={{ pageSize: pageSize, total: totalRecords, showSizeChanger: true, position: ['bottomCenter'], current: currentPage, pageSizeOptions: [10, 20, 50, 100, 200] }} onChange={onTableChange} loading={{ indicator: <div><Spin /></div>, spinning: isLoading }}
                size='small' scroll={{
                    x: 500,
                }}

                {...props}
            />

        </>
    )
}
